import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M0 8c0-4.406 3.563-8 8-8 4.406 0 8 3.594 8 8 0 4.438-3.594 8-8 8-4.438 0-8-3.563-8-8zm11.594-1.375a.849.849 0 000-1.219.849.849 0 00-1.219 0L7 8.781 5.594 7.406a.85.85 0 00-1.219 0 .85.85 0 000 1.219l2 2a.849.849 0 001.219 0l4-4z" fill="#1DA57C" /></svg>);